import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing, typography, borderRadius } = useTheme();

  return {
    base: css`
      background-color: ${colors.white};
      box-shadow: 0px 4px 6px rgba(91, 104, 133, 0.1);
      border-radius: 8px;
      position: relative;
      display: grid;
      align-items: center;
      justify-items: center;
      width: 100%;
      grid-auto-rows: 200px;
      padding: ${spacing.m} ${spacing.s};
      grid-auto-columns: 1fr;
      text-align: center;

      ${breakpoints.m} {
        grid-auto-rows: 280px;
        max-height: 280px;
        padding: 0;
      }
    `,
    header: css`
      font-size: 1.75rem;
      line-height: 1.625rem;
      padding: 0 0 ${spacing.s} 0;

      ${breakpoints.m} {
        ${typography.headings[5].desktop};
        padding: 30px;
      }

      ${breakpoints.xl} {
        padding: 0 0 ${spacing.s} 0;
      }

      color: ${colors.navy};
      position: relative;
      margin-bottom: ${spacing.s};
      text-align: center;
      &::before {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        height: ${borderRadius.s};
        width: 100px;
        background: ${colors.red};
        left: 50%;
        transform: translate(-50%, -50%);
      }
    `,
    description: css`
      p {
        color: ${colors.darkGrey};
        line-height: 1.3rem;
        padding: 0 ${spacing.s};

        ${breakpoints.m} {
          line-height: 0.8rem;
        }
      }
    `,
    newSearch: css`
      color: ${colors.darkGrey};
      display: inline-block;
      font-weight: 400;
      margin-left: 3px;
      text-decoration: none;
      border-bottom: 1.5px solid ${colors.darkGrey};
      display: inline-block;
      padding: 0;
    `,
    cta: css`
      background-color: ${colors.red};
      color: ${colors.white};
      text-transform: uppercase;
      max-width: 17.625rem;
      margin: 0 auto;
      margin-top: ${spacing.s};
      text-transform: uppercase;

      ${breakpoints.l} {
        width: 17.625rem;
      }
    `,
  };
};
